import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const lng = ["fr"];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  return (
    <div className="absolute top-5 right-5">
      <select onChange={(e) => changeLanguage(e.target.value)}>
        {lng.map((e) => (
          <option value={e} selected={i18n.language === e}>
            {e}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;
